import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { getInstallableModuleInfo } from '../../../../selectors/layout';
import { Props } from './WidgetTypeCard';

export type ConnectedKeys = 'limit' | 'restrict' | 'installedCount';
export type ContainerProps = Without<Props, ConnectedKeys>;

const mapStateToProps = (
  state: AppState,
  props: ContainerProps
): Partial<Props> => {
  const { limit = 0, restrict = undefined, installedCount = 0 } =
    (getInstallableModuleInfo(state, props.section, props.zone) || []).find(
      module => module.moduleName === props.moduleName
    ) || {};
  return {
    limit,
    restrict,
    installedCount,
  };
};

export default connect(mapStateToProps);
